<div class="text-center mat-bg-primary pt-1 pb-1">
  <h6 class="m-0">Seleccione</h6>
</div>
<mat-nav-list class="notification-list tarifario-list" role="list">
  <!-- Notification item -->
  @for (n of tarifario(); track n.type) {
    <mat-list-item class="notific-item" role="listitem" (click)="togglrTarifario(n.type)"
      routerLinkActive="open">
      @if (!!n.urlIframe) {
        <a [routerLink]="[n.route || '/dashboard']">
          <mat-icon [color]="n.color" class="notific-icon mr-1">{{ n.icon }}</mat-icon>
          <div class="mat-list-text">
            <h4 class="message" (click)="togglrTarifario(n.type);messageTitle.emit(n.message)">{{ n.message }}</h4>
            <small class="time text-muted">{{ n.time }}</small>
          </div>
        </a>
      }
      @if (!n.urlIframe) {
        <a>
          <mat-icon [color]="n.color" class="notific-icon mr-1">{{ n.icon }}</mat-icon>
          <div class="mat-list-text">
            <h4 class="message" (click)="togglrTarifario(n.type); messageTitle.emit(n.message)">{{ n.message }}</h4>
            <small class="time text-muted">{{ n.time }}</small>
          </div>
        </a>
      }
    </mat-list-item>
  }
</mat-nav-list>
